import React from 'react'
import { GashaponList as GashaponListComponent } from "../../../Components/Player/GashaponList"
import { Flex } from 'antd'
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

export const GashaponList = () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });

  return (
    <Flex justify='center' align='center'>
      {
        isDesktopOrLaptop ? navigate("/404") : <GashaponListComponent />
      }
    </Flex>
  )
}
